/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export default styled(Box)(({ theme, ownerState }) => {
  const { palette, typography, borders, functions } = theme;
  const { color } = ownerState;

  const { white, alertColors } = palette;
  const { fontSizeRegular, fontWeightMedium } = typography;
  const { borderWidth, borderRadius } = borders;
  const { pxToRem, linearGradient } = functions;

  // backgroundImage value
  const backgroundImageValue = alertColors[color]
    ? linearGradient(alertColors[color].main, alertColors[color].state)
    : linearGradient(alertColors.info.main, alertColors.info.state);

  // border value
  const borderValue = alertColors[color]
    ? `${borderWidth[1]} solid ${alertColors[color].border}`
    : `${borderWidth[1]} solid ${alertColors.info.border}`;

  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    // Size added
    minHeight: ownerState.size === "sm" ? pxToRem(45) : pxToRem(60),
    padding: ownerState.size === "sm" ? `${pxToRem(6)} ${pxToRem(12)}` : pxToRem(16),

    backgroundImage: backgroundImageValue,
    color: white.main,
    position: "relative",

    marginBottom: ownerState.size === "sm" ? pxToRem(8) : pxToRem(16),

    border: borderValue,
    borderRadius: ownerState.size === "sm" ? "9px" : borderRadius.md,

    fontSize: ownerState.size === "sm" ? "15px" : fontSizeRegular,

    fontWeight: fontWeightMedium,
    lineHeight: 1.4,
  };
});
